module.exports = __webpack_public_path__ + "static/img/ydh1_title_bg.d8a7fb8a.png";